import DateRangePicker from "./index.vue";
import { register } from "@various/utils";

export const UiDateRangePicker = register.use(DateRangePicker, "component") as typeof DateRangePicker;

export * from "./src/component";
export default UiDateRangePicker;
